// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1rVpX","signatureBlock":"Footer_signatureBlock__1dM-u","signature":"Footer_signature__2OmTm"};